import t from '../../../react-translate';

export default {
  bindings: {
    lectureComponent: '<',
    editMode: '<',
    restrictedEditMode: '<',
    reorderMode: '<',
    index: '<',
    context: '<',
  },
  controller: function ctrl(
    $controller,
    nvUtil,
    LectureComponentsHelper,
    InstitutionsManager,
  ) {
'ngInject';
    angular.extend(this, $controller('LectureComponentBaseCtrl'));
    const vm = this;

    vm.institutionsManager = InstitutionsManager;
    vm.institutionsManager.initialize(vm.CurrentUserManager.currentInstitution.id);

    /* Admin Actions */
    vm.editBasics = () => {
      vm.lectureComponent.createDraft();

      const modalInstance = LectureComponentsHelper.showEditModal(vm.lectureComponent);

      modalInstance.result.then(() => {
        const closeModal = LectureComponentsHelper.showSavingOverlay();

        vm.lectureComponent.saveDraft().then(closeModal, closeModal);
      });
    };

    vm.saveTitleOnBlur = () => {
      vm.lectureComponent.save();
    };

    vm.isDiscussionEditDisabled = function () {
      return vm.institutionsManager.institution.disableDiscussionEdits;
    };

    vm.setEditMenu = () => {
      const { sharedProps } = this.context;
      const extraOptions = [];
      extraOptions.push(sharedProps.extraOptions.getEditOption(t.LECTURE_PAGES.COMPONENTS.DISCUSSION.EDIT_BASICS()));
      sharedProps.extraOptions = {
        ...sharedProps.extraOptions,
        ...{
          options: extraOptions,
        },
      };
    };

    vm.setEditMenu();
  },
  controllerAs: 'vm',
  templateUrl: 'lecture_pages/templates/components/nv-discussion-lecture-component.html',
};
